import React from 'react'
import DatingCard from 'react-tinder-card'
import './DatingCards.css'
import { useState } from 'react'

const DatingCards = () => {
    const [people, setPeople] = useState([
{ name: "Random Guy", imgUrl: "https://images.unsplash.com/photo-1520409364224-63400afe26e5?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=658&q=80" },
{ name: "Ussama Azam", imgUrl: "https://images.unsplash.com/photo-1570915226741-cc7d678ad7ce?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1028&q=80" },
{ name: "Salem Ochidi", imgUrl: "https://images.unsplash.com/photo-1598343672916-de13ab0636ed?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1015&q=80" },
{ name: "Another Guy", imgUrl: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1064&q=80" },
{ name: "Random Girl", imgUrl: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80" },
{ name: "Another Girl", imgUrl: "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80" },
{ name: "Another Girl", imgUrl: "https://images.unsplash.com/photo-1615367840621-d387aef43326?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1065&q=80" },
{ name: "Another Girl", imgUrl: "https://images.unsplash.com/photo-1625474407059-8c543b6d1fc6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1480&q=80" }
    ])
        
    const onSwipe = (direction) => {
        console.log('You swiped: ' + direction)
      }
      
      const onCardLeftScreen = (myIdentifier) => {
        console.log(myIdentifier + ' left the screen')
      }





  return (
      <div className="datingCards">
          <div className="datingCards__container">
              {people.map((person) => (
                  <DatingCard
                      className="swipe"
                      key={person.name}
                      preventSwipe={['up', 'down']}
                      onSwipe={(dir) => onSwipe(dir, person.name)}
                      onCardLeftScreen={() => onCardLeftScreen(person.name)} >
                      <div style={{ backgroundImage: `url(${person.imgUrl})` }} className="card">
                          <h3>{person.name}</h3>
                      </div>
                  </DatingCard>
              ))}
          </div>
      </div>

 
  )
}

export default DatingCards